<template>
  <TableCell
    :tag="tag"
    :popoverTitle="popoverTitle"
    :showingPopover="showingPopover"
    :selectedCells="selectedCells"
    @update:showingPopover="value => $emit('update:showingPopover', value)"
    @update:columnSelectionCode="value => $emit('update:columnSelectionCode', value)"
  >
    {{ tag.status.value }}
    <template #PopoverContentDesktop>
      <div class="ThermostatStatus-popoverContent">
        <div class="popoverHeader">
          <h3>
            {{ popoverTitle }}
          </h3>
          <div style="flex-grow: 1;"></div>
          <Button text severity="secondary" style="margin-left: 10px; margin-right: -10px; color: gray; border: 0;" @click="$emit('update:showingPopover', false)">
            <i class="pi pi-times"></i>
          </Button>
        </div>
        <div class="popoverBody">
          <div class="scroll">
            <div style="display: flex; gap: 20px; justify-content: center;">
              <SingleColumnTable
                :session="tag.$session"
                :tableData="settingsTable"
                :column="0"
              ></SingleColumnTable>
            </div>
          </div>
          <Button severity="secondary" size="small" @click="onClickMoreSettings()">
            More settings
          </Button>
        </div>
      </div>
    </template>
  </TableCell>
</template>

<script>
// import CloseIcon from "./CloseIcon.vue";
// import PopoverElement from "./PopoverElement.vue";
import SingleColumnTable from "./SingleColumnTable.vue";
import TableCell from "./TableCell.vue";
import { createSingleColumnTableData, resolveTable } from "./TableUtility.js";

export default {
  components: { SingleColumnTable },
  props: [
    "tag",
    "options",
    "popoverTitle",
    "showingPopover",
    "columnSelectionCode",
    "selectedCells",
    "settings"
  ],
  computed: {
    settingsTable() {
      if (this.settings == "" || this.settings == null) return null;
      
      // Convert from dashed-lowercase to camelCase (eg 'abc-xyz' to 'abcXyz').
      let tableKey = this.settings;
      let system = this.tag.$session.system;
      let bins = system.bins.children;
      let bin = this.tag.$parents().find(parent => bins.includes(parent));
      let tableData = system.tables[tableKey]?.value;
      let columnIndex = bin?.$key();
      let singleColumnTableData = createSingleColumnTableData(tableData, columnIndex);
      let resolved = resolveTable(this.tag.$session, system, singleColumnTableData);

      // Include only settings from the table that belong to the given thermostat or to no particular thermostat.
      let thermostats = [ ... bin.refrigerationUnits.children, ... bin.heatingUnits.children ];
      resolved.rows = resolved.rows.filter(row => {
        let tag = row.cells[0].componentArgs.tag;
        let lineage = [ ... tag?.$parents(), tag ];
        return (lineage.includes(this.tag) || !lineage.find(tag => thermostats.includes(tag)));
      });
      resolved.rows.forEach(row => {
        let namePrefix = `${this.tag.name.value} |`;
        if (row.rowName.startsWith(namePrefix))
          row.rowName = row.rowName.slice(namePrefix.length);
      });
      return resolved;
    }
  },
  methods: {
    onClickMoreSettings() {
      if (this.settings == "refrigPopoverSettings")
        this.$router.push("refrigSettings");
      else
        this.$router.push("heatSettings");
    }
  }
}
</script>

<style>
.ThermostatStatus-popoverContent {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}
.ThermostatStatus-popoverContent .popoverHeader {
  align-self: stretch;
  display: flex;
  align-items: center;
  gap: 5px;
  min-width: 350px;
}
.ThermostatStatus-popoverContent .popoverBody {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}
.thermostat-status.no-popoverBody .popoverBody {
  display: none;
}
.ThermostatStatus-popoverContent .scroll {
  max-height: 80vh;
  overflow: auto;
}
.ThermostatStatus-popoverContent .tag-table {
  margin: 0;
}
.ThermostatStatus-popoverContent .table {
  width: initial;
  margin: auto;
}
.single-bin .ThermostatStatus-popoverContent .tag-table:not(.showAllBins) thead {
  display: none;
}
.ThermostatStatus-popoverContent .tag-table:not(.showAllBins) thead th {
  text-align: center;
  padding: 0;
  height: 36px;
}
.ThermostatStatus-popoverContent .tag-table:not(.showAllBins) thead th:first-child {
  width: initial;
}
.ThermostatStatus-popoverContent .tag-table:not(.showAllBins) th {
  border: 0;
  text-align: left;
  background: transparent;
  padding-left: 0;
}
.ThermostatStatus-popoverContent .tag-table:not(.showAllBins) td {
  border: 0;
  padding-right: 0px;
}
#app .ThermostatStatus-popoverContent .tag-table:not(.showAllBins) tbody tr:first-of-type td {
  border-top: 0;
}
#app .ThermostatStatus-popoverContent .tag-table:not(.showAllBins) tbody tr:last-of-type td {
  border-bottom: 0;
}
</style>